export const ReportTargetType = {
	POST: "post",
	COMMENT: "comment",
	MEMBER: "member",
} as const;
export type ReportTargetType = (typeof ReportTargetType)[keyof typeof ReportTargetType];

export const ReportStatus = {
	PENDING: "pending",
	IGNORED: "ignored",
	RESOLVED: "resolved",
} as const;
export type ReportStatus = (typeof ReportStatus)[keyof typeof ReportStatus];

export const ReportAction = {
	IGNORE: "ignore",
	DELETE_CONTENT: "delete_content",
	BAN_MEMBER: "ban_member",
} as const;
export type ReportAction = (typeof ReportAction)[keyof typeof ReportAction];

export const ReportReason = {
	SPAM: "spam",
	HARASSMENT: "harassment",
	INAPPROPRIATE: "inappropriate",
	MISINFORMATION: "misinformation",
	OTHER: "other",
} as const;
export type ReportReason = (typeof ReportReason)[keyof typeof ReportReason];

export const ReportStatusFilter = {
	ALL: "all",
	PENDING: "pending",
	IGNORED: "ignored",
	RESOLVED: "resolved",
} as const;
export type ReportStatusFilter = (typeof ReportStatusFilter)[keyof typeof ReportStatusFilter];
